export default "__VITE_ASSET__BmiNsX6o__"